import Box from "@material-ui/core/Box"
import { Route } from "react-router"

export default function Maps({ path }) {
  return (
    <Route path={`${path}`}>
      <Box>Maps</Box>
    </Route>
  )
}
